import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getJson } from '@hcr/api/shared'

import type { ErrorDto, TranslationsDto } from '../../dtos'
import { TranslationsDtoSchema } from '../../dtos'

interface TranslationsQueryParams {
  categoryId: string
}

export const createTranslationsQueryKey = (params: TranslationsQueryParams) => ['optimizely', 'translations', params]

export const createTranslationsQuery =
  (baseUrl: string) =>
  <Data = TranslationsDto>(
    params: TranslationsQueryParams,
    options?: Partial<UseQueryOptions<TranslationsDto, ErrorDto, Data>>
  ) =>
    useQuery<TranslationsDto, ErrorDto, Data>({
      ...options,
      queryKey: createTranslationsQueryKey(params),
      queryFn: () =>
        getJson({
          schema: TranslationsDtoSchema,
          url: `${baseUrl}/translations/${params.categoryId}`,
        }),
    })
